import React, { ReactNode } from 'react';
import styled from 'styled-components';

type Props = {
  children: ReactNode;
  height: string;
};

const OverflowBody = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
`;

const Wrapper = styled.div<Props>`
  height: ${(props) => props.height};
  overflow-y: auto;
  position: relative;
`;

export default function OverflowScroll(props: Props) {
  const { children } = props;
  return (
    <Wrapper {...props}>
      <OverflowBody>{children}</OverflowBody>
    </Wrapper>
  );
}
